{
  "name": "@gymki/app",
  "version": "1.7.0",
  "author": "Technit",
  "homepage": "https://technit.app/",
  "scripts": {
    "start": "nx run app:serve",
    "build": "nx run app:build",
    "test": "jest --coverage",
    "test:watch": "jest --coverage --watchAll",
    "test:ci": "jest --ci --coverage --runInBand --no-cache",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:ci": "playwright test",
    "lint": "eslint . --max-warnings 0",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write ."
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@awesome-cordova-plugins/calendar": "^6.14.0",
    "@capacitor-community/apple-sign-in": "^7.0.1",
    "@capacitor-community/stripe": "^7.0.1",
    "@capacitor/android": "^7.6.10",
    "@capacitor/app": "^7.0.1",
    "@capacitor/barcode-scanner": "^2.0.3",
    "@capacitor/cli": "^7.6.10",
    "@capacitor/core": "^7.6.10",
    "@capacitor/device": "^7.0.1",
    "@capacitor/filesystem": "^7.0.1",
    "@capacitor/geolocation": "^7.1.1",
    "@capacitor/haptics": "^7.0.1",
    "@capacitor/ios": "^7.6.10",
    "@capacitor/keyboard": "^7.0.1",
    "@capacitor/preferences": "^7.0.1",
    "@capacitor/share": "^7.0.1",
    "@capacitor/splash-screen": "^7.0.1",
    "@capacitor/status-bar": "^7.0.1",
    "@capgo/capacitor-social-login": "^7.11.10",
    "@google/markerclusterer": "^2.0.9",
    "@googlemaps/markerclusterer": "^2.6.2",
    "@ionic/angular": "^9.0.10",
    "@ionic/core": "^9.0.10",
    "@ngx-translate/core": "^18.1.0",
    "@ngx-translate/http-loader": "^18.1.0",
    "@stripe/stripe-js": "^4.10.0",
    "angularx-qrcode": "^22.0.1",
    "capacitor-screenshot": "^7.0.0",
    "card-validator": "^10.0.4",
    "cordova-plugin-calendar": "^5.1.6",
    "crypto-js": "^4.2.0",
    "html2canvas": "^1.4.1",
    "ionicons": "^8.1.0",
    "moment": "^2.31.0",
    "moment-timezone": "^0.5.48",
    "onesignal-cordova-plugin": "^5.2.15",
    "rxjs": "~7.8.2",
    "tslib": "^2.9.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/schematics": "^22.6.0",
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@angular/language-service": "^22.2.4",
    "@eslint/js": "^10.0.1",
    "@hirez_io/observer-spy": "^2.2.0",
    "@ionic/angular-toolkit": "13.0.0",
    "@playwright/test": "^1.64.1",
    "@types/crypto-js": "^4.2.2",
    "@types/google.maps": "^3.66.9",
    "@types/jest": "^30.0.0",
    "@types/moment": "^2.13.0",
    "@types/node": "^24.19.2",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.14.0",
    "eslint-plugin-rxjs-x": "^1.0.6",
    "jest": "^30.5.2",
    "jest-environment-jsdom": "^30.5.2",
    "jest-mock-extended": "^4.0.2",
    "jest-preset-angular": "^17.0.3",
    "jest-silent-reporter": "^0.5.0",
    "jsdom": "^26.1.0",
    "prettier": "^3.9.10",
    "ts-node": "^10.9.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.1"
  },
  "description": "An Ionic project",
  "browserslist": [
    "Chrome >=89",
    "ChromeAndroid >=89",
    "Firefox >=78",
    "Edge >=89",
    "Safari >=16",
    "iOS >=16"
  ]
}
